(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
(function () {
  if (window.__cartMilestonesInit) return;
  window.__cartMilestonesInit = true;

  /* ---------- scroll position keeper (fixes jump-to-top after remove / qty change) ---------- */
  var savedScroll = 0;
  var lockUntil = 0;

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (Date.now() < lockUntil) return;
    if (t && t.nodeType === 1 && t.classList && t.classList.contains('drawer__content') && t.closest('#mini-cart')) {
      savedScroll = t.scrollTop;
    }
  }, { capture: true, passive: true });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#mini-cart .drawer__close-button, #mini-cart .drawer__overlay')) {
      savedScroll = 0;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') savedScroll = 0;
  });

  var forceTop = false;

  function restoreScroll(host) {
    if (forceTop) {
      forceTop = false;
      savedScroll = 0;
      lockUntil = Date.now() + 700;
      var goTop = function () {
        var c = (host && host.closest('.drawer__content')) || document.querySelector('#mini-cart .drawer__content');
        if (c) c.scrollTop = 0;
      };
      goTop();
      requestAnimationFrame(goTop);
      setTimeout(goTop, 150);
      return;
    }
    if (!savedScroll) return;
    var target = savedScroll;
    lockUntil = Date.now() + 700;
    var apply = function () {
      var c = (host && host.closest('.drawer__content')) || document.querySelector('#mini-cart .drawer__content');
      if (c && c.scrollTop !== target) c.scrollTop = target;
    };
    apply();
    requestAnimationFrame(apply);
    setTimeout(apply, 150);
  }



  /* ---------- cross-sell / B2G1 : add to cart ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#mini-cart .rec-card__add[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var card = btn.closest('.rec-card');
    var select = card && card.querySelector('.rec-card__select');
    var variantId = select ? select.value : btn.dataset.variantId;
    var label = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Skip-Offer-Auto': '1' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (data) {
        var item = data.items && data.items[0];
        var detail = { items: data.items || [], variant: item || null, quantity: 1, fromDrawer: true };
        document.documentElement.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: detail }));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });

  /* ---------- offer chooser: Milestone OR Buy 2 Get 1 Free ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#mini-cart [data-offer-choice]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var choice = btn.getAttribute('data-offer-choice');
    forceTop = true;
    savedScroll = 0;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.disabled = true;

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { offer_choice: choice } })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('update failed');
        return res.json();
      })
      .then(function (cart) {
        var detail = { items: (cart && cart.items) || [], variant: null, quantity: 0 };
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
      })
      .catch(function () {
        btn.disabled = false;
      });
  });

  /* ---------- recommendations: reuse old DOM node, no blink ---------- */
  var recKeep = null;
  var recSig = '';
  var recBusy = false;

  function recSignature(root) {
    return Array.prototype.map.call(root.querySelectorAll('.rec-card__title'), function (a) {
      return a.getAttribute('href');
    }).join('|');
  }

  function saveRecs() {
    var host = document.querySelector('#mini-cart cart-drawer-recommendations');
    var inner = host && host.querySelector('.mini-cart__recommendations-inner');
    if (inner && inner.querySelector('.rec-card')) {
      recKeep = inner;
      recSig = recSignature(inner);
    }
  }

  function resetRecButtons(root) {
    root.querySelectorAll('.rec-card__add').forEach(function (b) {
      if (b.textContent === 'Adding...') {
        b.disabled = false;
        b.textContent = 'Add to cart';
      }
    });
  }

  var allowRefresh = false;

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#mini-cart .drawer__close-button, #mini-cart .drawer__overlay')) {
      allowRefresh = true;
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') allowRefresh = true;
  });

  function hideRecsInCart(root) {
    if (!root) return;
    var inCart = {};
    document.querySelectorAll('#mini-cart .line-item__image-wrapper').forEach(function (a) {
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (m) inCart[m[1]] = true;
    });
    root.querySelectorAll('.rec-card').forEach(function (card) {
      var t = card.querySelector('.rec-card__title');
      var m = t && (t.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      card.style.display = (m && inCart[m[1]]) ? 'none' : '';
    });
  }

  new MutationObserver(function () {
    if (recBusy) return;
    recBusy = true;
    try {
      var host = document.querySelector('#mini-cart cart-drawer-recommendations');
      if (host && recKeep) {
        var cur = host.querySelector('.mini-cart__recommendations-inner');
        if (cur !== recKeep) {
          var hasCards = cur && cur.querySelector('.rec-card');
          if (hasCards && allowRefresh) {
            allowRefresh = false;
          } else {
            resetRecButtons(recKeep);
            host.replaceChildren(recKeep);
          }
        }
      }
      saveRecs();
      if (host) hideRecsInCart(host.querySelector('.mini-cart__recommendations-inner'));
    } finally {
      recBusy = false;
    }
  }).observe(document.body, { childList: true, subtree: true });

  saveRecs();

  /* ---------- Add kahan se hua: B2G1 page => B2G1 active, baaki pages => Milestone active ---------- */
  (function () {
    var origFetch = window.fetch;

    function isB2g1Page() {
      var cfg = document.querySelector('#mini-cart .b2g1-config');
      if (!cfg) return false;
      var here = location.pathname.toLowerCase().replace(/\/+$/, '');
      return (cfg.getAttribute('data-paths') || '').split('|').some(function (p) {
        p = p.trim();
        try { if (/^https?:/.test(p)) p = new URL(p).pathname; } catch (e) {}
        p = p.replace(/\/+$/, '');
        return p && (here === p || here.indexOf(p + '/') === 0);
      });
    }

    window.__isB2g1Page = isB2g1Page;

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      var skip = init && init.headers && init.headers['X-Skip-Offer-Auto'];

      if (skip || !/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        return origFetch.apply(this, arguments);
      }

      var self = this, args = arguments;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var choice = isB2g1Page() ? 'b2g1' : 'milestone';

      allowRefresh = true; /* "You may also like" naye product ke hisaab se refresh ho */
      forceTop = true;

      return origFetch.call(self, root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { offer_choice: choice } })
      })
        .catch(function () {})
        .then(function () { return origFetch.apply(self, args); });
    };
  })();

  /* ---------- BACKUP: add ke baad offer_choice page ke hisaab se verify/fix ---------- */
  document.documentElement.addEventListener('variant:added', function (e) {
    var d = e.detail || {};
    if (d.fromDrawer) return;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var want = (window.__isB2g1Page && window.__isB2g1Page()) ? 'b2g1' : 'milestone';

    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cur = cart.attributes && cart.attributes.offer_choice;
        if (cur === want) return;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { offer_choice: want } })
        }).then(function (r) { return r.json(); }).then(function (c) {
          allowRefresh = true;
          forceTop = true;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { items: (c && c.items) || [], variant: null, quantity: 0 }
          }));
        });
      })
      .catch(function () {});
  });

  /* ---------- Combo add hone par popup ---------- */
  (function () {
    var KEY = 'b2g1_combo_qty';
    var queued = false;

    function store(v) {
      try { if (v === undefined) return sessionStorage.getItem(KEY); sessionStorage.setItem(KEY, String(v)); } catch (e) {}
      return null;
    }

    function showPopup() {
      if (document.getElementById('combo-popup')) return;
      var w = document.createElement('div');
      w.id = 'combo-popup';
      w.className = 'combo-popup';
      w.innerHTML = '<div class="combo-popup__box" role="alertdialog">' +
        '<p class="combo-popup__title">Combo pack added</p>' +
        '<p class="combo-popup__text">Buy 2 Get 1 Free is not valid on combo packs. Get Flat ₹100 OFF on orders above ₹999!</p>' +
        '<button type="button" class="combo-popup__btn">OK</button></div>';
      w.addEventListener('click', function (e) {
        if (e.target === w || (e.target.closest && e.target.closest('.combo-popup__btn'))) w.remove();
      });
      document.body.appendChild(w);
    }

    function check() {
      queued = false;
      var flag = document.querySelector('#mini-cart .combo-flag');
      if (!flag) {
        if (document.querySelector('#mini-cart .drawer__content--center')) store(0);
        return;
      }
      var qty = Number(flag.getAttribute('data-combo-qty')) || 0;
      var last = store();
      if (last === null || last === undefined) { store(qty); return; }
      last = Number(last);
      if (qty > last) showPopup();
      if (qty !== last) store(qty);
    }

    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(check);
    }).observe(document.body, { childList: true, subtree: true });

    check();
  })();

  /* ---------- Add to cart ke baad drawer ko turant slide-in karo ---------- */
  function openMiniCartDrawer() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;

    if (drawer.hasAttribute('open') || drawer.getAttribute('aria-hidden') === 'false') return;

    var toggle = document.querySelector('[is="toggle-link"][aria-controls="mini-cart"]');
    if (toggle) {
      toggle.click();
      return;
    }

    if (typeof drawer.show === 'function') {
      drawer.show();
    } else {
      drawer.setAttribute('open', '');
    }
  }

  ['variant:added', 'cart:refresh'].forEach(function (evt) {
    document.documentElement.addEventListener(evt, function (e) {
      var d = e.detail || {};
      var isAdd = evt === 'variant:added' || (d.quantity && d.quantity > 0);
      if (!isAdd) return;
      setTimeout(openMiniCartDrawer, 150);
    });
  });

  /* ---------- "Item added / View Cart" bar: drawer khula ho to chhupao, band ho to wapas ---------- */
  (function () {
    var hiddenBars = [];
    var queued = false;

    function drawerOpen() {
      var d = document.getElementById('mini-cart');
      return !!d && (d.hasAttribute('open') || d.getAttribute('aria-hidden') === 'false');
    }

    function findBars() {
      var found = [];
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (!/^\s*item added\s*$/i.test(node.nodeValue)) continue;
        var el = node.parentElement;
        if (!el || el.closest('#mini-cart')) continue;
        var bar = null;
        var p = el;
        for (var i = 0; i < 8 && p && p !== document.body; i++) {
          if (getComputedStyle(p).position === 'fixed') { bar = p; break; }
          p = p.parentElement;
        }
        if (bar && found.indexOf(bar) === -1) found.push(bar);
      }
      return found;
    }

    function update() {
      queued = false;
      if (drawerOpen()) {
        findBars().forEach(function (bar) {
          if (hiddenBars.indexOf(bar) === -1) {
            bar.style.setProperty('display', 'none', 'important');
            hiddenBars.push(bar);
          }
        });
      } else if (hiddenBars.length) {
        hiddenBars.forEach(function (bar) {
          bar.style.removeProperty('display');
        });
        hiddenBars = [];
      }
    }

    function queue() {
      if (queued) return;
      queued = true;
      setTimeout(update, 250);
    }

    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    var drawer = document.getElementById('mini-cart');
    if (drawer) {
      new MutationObserver(queue).observe(drawer, { attributes: true, attributeFilter: ['open', 'aria-hidden'] });
    }
    queue();
  })();

  /* ---------- "View Cart" button / koi bhi /cart link => cart page ki jagah drawer kholo ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var el = e.target.closest && e.target.closest('a, button');
    if (!el) return;

    // drawer ke andar ke links ya header ke apne cart toggle ko mat chhedo
    if (el.closest('#mini-cart')) return;
    if (el.getAttribute('aria-controls') === 'mini-cart') return;

    var isCartLink = false;

    if (el.tagName === 'A') {
      var href = el.getAttribute('href') || '';
      try {
        var path = new URL(href, location.origin).pathname.replace(/\/+$/, '').toLowerCase();
        var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/+$/, '').toLowerCase();
        if (path === root + '/cart') isCartLink = true;
      } catch (err) {}
    }

    // text "View Cart" wale button/link ke liye
    if (!isCartLink && /^\s*view\s*cart\s*$/i.test(el.textContent || '')) {
      isCartLink = true;
    }

    if (!isCartLink) return;

    // agar already cart page par ho to normal chalne do
    if (/\/cart\/?$/.test(location.pathname)) return;

    var toggle = document.querySelector('[is="toggle-link"][aria-controls="mini-cart"]');
    if (!toggle) return; // drawer toggle nahi mila to default behaviour

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    toggle.click();
  }, true);

  /* ---------- milestone bar element (scroll restore only) ---------- */
  class CartMilestones extends HTMLElement {
    connectedCallback() {
      restoreScroll(this);
    }
  }

  if (!customElements.get('cart-milestones')) {
    customElements.define('cart-milestones', CartMilestones);
  }
})();


  } catch(e) { console.error(e); }
})();
})();
